import { useTranslation } from 'react-i18next';
import * as S from './LoginRelatedComponents.style';
import emailPatternBg from '../../assets/icons/EmailPatternBg.svg';
import signInUpEmail from '../../assets/icons/SignInUpEmail.svg';
import RedisLogo from './RedisLogo';
import UserFormInfo from '../../screens/Login/components/UserFormInfo/UserFormInfo';
import { parametersQueries } from '../../queryClient/parameters/parameters.queries';
import { i18translation } from '../../locale/translations/i18NsPaths';

const ThanksForSignUp = () => {
  const keyPrefix = i18translation.LoginScreen.thanksForSignUp;
  const { systemParams } = parametersQueries.useSystemParameters();
  const { t } = useTranslation();

  return (
    <>
      {systemParams.external_feature_flag_new_login_enabled ? (
        <UserFormInfo
          title={t(keyPrefix.thanksTitle)}
          subTitle={t(keyPrefix.checkEmail)}
          text={t(keyPrefix.checkEmailActivationMessage)}
          showBackToLoginButton={false}
        />
      ) : (
        <S.ThanksForSignUpContainer>
          <img src={emailPatternBg} alt="background with starts" />

          <RedisLogo />

          <S.ThanksForSignUpTitle>{t(keyPrefix.thanksTitle)}</S.ThanksForSignUpTitle>

          <img src={signInUpEmail} alt={t(keyPrefix.signInUpEmail)} />

          <S.CheckEmailText>{t(keyPrefix.checkEmail)}</S.CheckEmailText>

          <S.ClickMessage>{t(keyPrefix.checkEmailMessage1)}</S.ClickMessage>
          <S.ClickMessage>{t(keyPrefix.checkEmailMessage2)}</S.ClickMessage>
        </S.ThanksForSignUpContainer>
      )}
    </>
  );
};

export default ThanksForSignUp;
